//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RoundedCheckmarkIcon from "~/components/icons/RoundedCheckmarkIcon.vue";

export default {
  name: "UiPropertyCard",
  components: {RoundedCheckmarkIcon},
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    image_src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
